<script>
import { EXAMINATION } from "@/utils/data.js";
export default {
  name: "paperBody",
  props: {
    testTitle: {
      type: String,
      default: "考试",
    },
    paperTitle: {
      type: String,
      default: "",
    },
    paperScore: {
      type: [String, Number],
      default: "",
    },
    questionList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      TYPE: EXAMINATION.TYPE,
      TYPE_NAME: EXAMINATION.TYPE_NAME,
      TRUE_OR_FALSE_OPTIONS: EXAMINATION.TRUE_OR_FALSE_OPTIONS,
    };
  },
  methods: {
    createOptions(options) {
      let list = [];
      try {
        list = JSON.parse(options);
      } catch (e) {
        console.log("转换失败", e);
      }
      return list;
    },
    createBlank(options) {
      console.log("输入框", options);
      try {
        let data = JSON.parse(options);
        return data.inputCount;
      } catch (e) {
        return 0;
      }
    },
  },
};
</script>

<template>
  <div>
    <p class="test-title">{{ testTitle }}</p>
    <p class="paper-title">{{ paperTitle }}</p>
    <p class="paper-score">{{ paperScore }}分</p>
    <div class="paper-list ml-20 mr-20">
      <div
        class="paper-question mb-2"
        v-for="(question, index) in questionList"
        :key="question.name"
      >
        <div class="question-title text-xl">
          {{ index + 1 }}、{{ question.name }}({{ TYPE_NAME[question.type] }})
        </div>
        <div v-if="question.type === TYPE.SINGLE">
          <div
            class="mr-10"
            v-for="option in createOptions(question.options)"
            :key="question.name + option.name"
          >
            {{ option.value }} 、 {{ option.name }}
          </div>
        </div>
        <div v-if="question.type === TYPE.MULTIPLE">
          <div
            class=""
            v-for="option in createOptions(question.options)"
            :key="question.name + option.name"
          >
            {{ option.value }} 、 {{ option.name }}
          </div>
        </div>
        <div v-if="question.type === TYPE.TRUE_OR_FALSE">
          <div
            class="mr-10"
            v-for="(option, index) in TRUE_OR_FALSE_OPTIONS"
            :key="question.name + option.name"
          >
            {{ index + 1 }} 、 {{ option.name }}
          </div>
        </div>
        <div v-if="question.type === TYPE.BLANK">
          <div
            class="mr-10 flex"
            v-for="option in createBlank(question.options)"
            :key="question.name + 'blank' + option"
          >
            {{ option }} 、
            <div class="w-48 border-b-2"></div>
          </div>
        </div>
        <div class="h-20" v-if="question.type === TYPE.INPUT"></div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.test-title {
  text-align: center;
  font-weight: bold;
  font-size: 26px;
}
.paper-title {
  text-align: center;
  font-weight: bold;
  font-size: 30px;
}
.paper-score {
  text-align: center;
}
</style>
